import React, { useState, useRef, useCallback } from "react";
import { Sun, Moon } from "lucide-react";
import Switch from "react-switch";
import {
  switchTheme,
  clickedClass,
  theme,
} from "../components/helper/themeHelper";

const containerStyle = { display: "flex", alignItems: "center", gap: "8px" };
const labelStyle = { marginTop: "10px", marginBottom: "10px", height: "20px" };

function DarkModeSwitch({ onChangeTheme }) {
  const [checked, setChecked] = useState(
    () => localStorage.getItem("theme") !== "theme-light"
  );
  const isReady = useRef(true);

  const handleChange = useCallback(
    (newChecked) => {
      if (isReady.current) {
        setChecked(newChecked);
        onChangeTheme();
        switchTheme();
        isReady.current = false;
        setTimeout(() => {
          isReady.current = true;
        }, 500);
      }
    },
    [onChangeTheme]
  );

  return (
    <div style={containerStyle}>
      {checked ? (
        <Sun size={16} color="#707070" style={{ transition: "transform 0.3s ease" }} />
      ) : (
        <Sun size={16} color="#F2994A" style={{ transition: "transform 0.3s ease" }} />
      )}
      <label
        htmlFor="dark-switch"
        style={labelStyle}
        className={`${theme === "dark" ? clickedClass : ""}`}
      >
        <Switch
          checked={checked}
          onChange={handleChange}
          offColor="#EEEEEE"
          onColor="#2A0000"
          offHandleColor="#F2994A"
          onHandleColor="#FF4444"
          handleDiameter={14}
          uncheckedIcon={false}
          checkedIcon={false}
          height={22}
          width={42}
          id="dark-switch"
          activeBoxShadow="0 0 0 3px rgba(204, 0, 0, 0.15)"
        />
      </label>
      {checked ? (
        <Moon size={16} color="var(--rc-brand-primary)" style={{ transition: "transform 0.3s ease" }} />
      ) : (
        <Moon size={16} color="#A3A3A3" style={{ transition: "transform 0.3s ease" }} />
      )}
    </div>
  );
}

export default DarkModeSwitch;
